/* mundizio 22.09.2026 -- Rabattcode im Warenkorb einloesen (snippets/md-rabattcode.liquid).
 * POST /cart/update.js { discount: "CODE" } -- Shopify prueft den Code und liefert discount_codes [{code, applicable}].
 * Ein nicht anwendbarer Code bleibt danach als applicable:false am Korb haengen; wir raeumen ihn mit
 * { discount: "" } wieder ab, damit er nicht an der Kasse als Fehler auftaucht.
 * Erfolg: im Drawer cart-drawer.refresh(true) (Section-Rendering, Zeilen bleiben), sonst Seite neu laden.
 * Delegiert auf document, weil der Drawer seinen Inhalt bei jeder Korbaenderung neu einsetzt. */
(function () {
  'use strict';

  // theme.routes.cartUpdate ist "/cart/update" (ohne .js); der JSON-Weg braucht die .js-Form.
  var UPDATE = ((window.theme && theme.routes && theme.routes.cartUpdate) || '/cart/update').replace(/\.js$/, '') + '.js';
  var laeuft = false;

  function fehler(box, text) {
    var p = box.querySelector('[data-md-rabatt-fehler]');
    if (!p) return;
    p.textContent = text || '';
    p.hidden = !text;
  }

  function update(discount) {
    return fetch(UPDATE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: discount })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); });
  }

  function neuZeichnen(box) {
    var drawer = box.closest('cart-drawer');
    if (drawer && typeof drawer.refresh === 'function') {
      drawer.refresh(true);
      return;
    }
    window.location.reload();
  }

  // Kein <form> (auf der Warenkorbseite laege es im Warenkorb-Formular): Knopf-Klick und Enter im Feld.
  function einloesen(form) {
    if (laeuft) return;
    var box = form.closest('[data-md-rabatt]');
    var feld = form.querySelector('input[name="md_rabatt_code"]');
    var code = (feld.value || '').trim();
    if (!code) { fehler(box, 'Bitte einen Rabattcode eingeben.'); feld.focus(); return; }
    laeuft = true;
    fehler(box, '');
    form.classList.add('is-loading');
    update(code).then(function (res) {
      var codes = (res.json && res.json.discount_codes) || [];
      var treffer = null;
      for (var i = 0; i < codes.length; i++) {
        if (String(codes[i].code).toLowerCase() === code.toLowerCase()) treffer = codes[i];
      }
      if (!res.ok || !treffer || treffer.applicable === false) {
        // Nicht anwendbar: Shopify laesst den Code am Korb stehen -- abraeumen, dann Fehlzeile.
        return update('').then(function () {
          fehler(box, 'Dieser Code ist ungültig oder auf diesen Warenkorb nicht anwendbar.');
        });
      }
      neuZeichnen(box);
    }).catch(function () {
      fehler(box, 'Der Code konnte gerade nicht geprüft werden. Bitte noch einmal versuchen.');
    }).then(function () {
      laeuft = false;
      form.classList.remove('is-loading');
    });
  }

  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Enter' || !ev.target.closest) return;
    var feld = ev.target.closest('input[name="md_rabatt_code"]');
    if (!feld) return;
    ev.preventDefault();
    einloesen(feld.closest('[data-md-rabatt-form]'));
  });

  document.addEventListener('click', function (ev) {
    var los = ev.target.closest && ev.target.closest('[data-md-rabatt-einloesen]');
    if (los) {
      ev.preventDefault();
      einloesen(los.closest('[data-md-rabatt-form]'));
      return;
    }
    var knopf = ev.target.closest && ev.target.closest('[data-md-rabatt-entfernen]');
    if (!knopf) return;
    ev.preventDefault();
    if (laeuft) return;
    // 22.09.: das x steht auch in der Rabattzeile des Gesamt-Blocks, ausserhalb des Aufklappers.
    var box = knopf.closest('[data-md-rabatt]') || knopf;
    laeuft = true;
    update('').then(function () { neuZeichnen(box); }).catch(function () {
      fehler(box, 'Der Code konnte gerade nicht entfernt werden.');
    }).then(function () { laeuft = false; });
  });
})();
